import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ForgetPasswordState {
  Id: number;
  newPassword: string;
  VerificationCode: string;
  UserPhoneNumber: string;
}

const initialState: ForgetPasswordState = {
  Id: -1,
  newPassword: "",
  VerificationCode: "",
  UserPhoneNumber: "",
};

const forgetPasswordSlice = createSlice({
  name: "forgetPassword",
  initialState,
  reducers: {
    setUserId(state, action: PayloadAction<number>) {
      state.Id = action.payload;
    },
    setUserNumber(state, action: PayloadAction<string>) {
      state.UserPhoneNumber = action.payload;
    },
    setVerificationCode(state, action: PayloadAction<string>) {
      state.VerificationCode = action.payload;
    },
    setNewPassword(state, action: PayloadAction<string>) {
      state.newPassword = action.payload;
    },
  },
});

export const { setUserId, setVerificationCode, setNewPassword, setUserNumber } =
  forgetPasswordSlice.actions;
export default forgetPasswordSlice.reducer;
